import posthog from 'posthog-js';

let isPostHogInitialized = false;

export function initPostHog() {
    if (typeof window === 'undefined') return;

    if (isPostHogInitialized) return;

    const key = process.env.REACT_APP_POSTHOG_KEY;
    const host = process.env.REACT_APP_POSTHOG_HOST;

    if (!key || !host) {
        if (process.env.NODE_ENV !== 'production') {
            console.warn(
                '[PostHog] Missing REACT_APP_POSTHOG_KEY or REACT_APP_POSTHOG_HOST'
            );
        }
        return;
    }

    posthog.init(key, {
        api_host: host,
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: false,
        session_recording: {
            maskAllInputs: true,
        },
        loaded: (ph) => {
            if (process.env.NODE_ENV !== 'production') {
                // ph.debug();
            } else {
                ph.debug(false);
            }
            isPostHogInitialized = true;
        },
    });

    isPostHogInitialized = true;
}

export { posthog };
